/***************************************************************
 * 🔥 MULTI-CART PARA EVENTOS — FULL LOCAL STORAGE
 ***************************************************************/

document.addEventListener("DOMContentLoaded", () => {
  const handle = window.collectionHandle || "general";
  const isEvent = window.isEventCollection === true;
  const cartKey = isEvent ? `cart_event_${handle}` : "cart_general";

  //console.log("🔥 multi-cart cargado");
  //console.log("🛒 CartKey:", cartKey, "| isEvent:", isEvent);

  /***************************************************************
   * LOCAL STORAGE
   ***************************************************************/
  function loadLocalCart() {
    let raw = localStorage.getItem(cartKey);
    console.log("📦 loadLocalCart:", raw);
    if (!raw) return { items: [] };

    try {
      return JSON.parse(raw);
    } catch (e) {
      //console.error("❌ Error parseando localStorage", e);
      return { items: [] };
    }
  }

  function saveLocalCart(cart) {
    //console.log("💾 saveLocalCart:", cart);
    localStorage.setItem(cartKey, JSON.stringify(cart));
  }

  /***************************************************************
   * ADD / UPDATE / REMOVE
   ***************************************************************/
  function addToLocal(variantId, qty, meta) {
    let cart = loadLocalCart();
    let item = cart.items.find(i => i.id === variantId);

    if (item) {
      item.quantity += qty;
    } else {
      cart.items.push({
        id: variantId,
        quantity: qty,
        handle: meta.handle || null,
        title: meta.title || "",
        price: meta.price || 0,      // en centavos
        image: meta.image || ""
      });
    }

    saveLocalCart(cart);
  }

  function updateLocalQty(variantId, qty) {
    let cart = loadLocalCart();
    let item = cart.items.find(i => i.id == variantId);
    if (!item) return;

    if (qty <= 0) {
      cart.items = cart.items.filter(i => i.id != variantId);
    } else {
      item.quantity = qty;
    }
    saveLocalCart(cart);
  }

  function removeLocalItem(variantId) {
    let cart = loadLocalCart();
    cart.items = cart.items.filter(i => i.id != variantId);
    saveLocalCart(cart);
  }

  /***************************************************************
   * INTERCEPTAR ADD TO CART (EVENTOS)
   ***************************************************************/
  document.body.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-add-to-cart]");
    if (!btn) return;

    if (!isEvent) return; // para colecciones normales no tocamos nada

    e.preventDefault();

    const form = btn.closest("form");
    const data = new FormData(form);

    const variantId = Number(data.get("id"));
    const quantity  = Number(data.get("quantity") || 1);

    // 🔹 meta desde data-attributes del form
    const meta = {
      handle: form.dataset.productHandle,
      title:  form.dataset.productTitle,
      price:  Number(form.dataset.productPrice || 0),
      image:  form.dataset.productImage
    };

    console.log("➕ ADD LOCAL EVENT:", { variantId, quantity, meta });

    addToLocal(variantId, quantity, meta);

    // Abrimos popup del carrito de evento
    openEventCartPopup();
  });

  /***************************************************************
   * POPUP EVENTO
   ***************************************************************/
  window.openEventCartPopup = function () {
    console.log("🟢 OPEN POPUP EVENT");
    const overlay = document.getElementById("event-cart-popup");
    if (!overlay) {
      console.warn("⚠️ No existe #event-cart-popup en el DOM");
      return;
    }
    overlay.style.display = "flex";
    renderEventCartItems();
  };

  window.closeEventCartPopup = function () {
    const overlay = document.getElementById("event-cart-popup");
    if (overlay) overlay.style.display = "none";
  };

  /***************************************************************
   * RENDER ITEMS POPUP
   ***************************************************************/
  window.renderEventCartItems = async function () {
    let cart = loadLocalCart();
    let container = document.getElementById("event-cart-items");
    let totalEl   = document.getElementById("event-cart-total");

    if (!container || !totalEl) {
      console.warn("⚠️ Falta contenedor de popup (#event-cart-items / #event-cart-total)");
      return;
    }

    if (!cart.items.length) {
      container.innerHTML = "<p>Your event cart is empty.</p>";
      totalEl.textContent = "£0.00";
      return;
    }

    container.innerHTML = "";
    let total = 0;

    for (let item of cart.items) {
      let title   = item.title;
      let image   = item.image;
      let price   = item.price; // en centavos
      let handle  = item.handle;

      // 🔹 Fallback: si falta info y tenemos handle, intentamos 1 fetch
      if ((!title || !image || !price) && handle) {
        try {
          const resp = await fetch(`/products/${handle}.js`);
          const data = await resp.json();
          const variant = data.variants.find(v => v.id == item.id);

          title = title || data.title;
          image = image || (data.images && data.images[0]);
          price = price || (variant ? variant.price : 0);
        } catch (err) {
          console.error("❌ Error obteniendo data de producto para", handle, err);
        }
      }

      total += (price || 0) * item.quantity;

      const unitPriceTxt = price ? `£${(price / 100).toFixed(2)} each` : "";
      const imgTag       = image ? `<img src="${image}" alt="">` : "";

      container.innerHTML += `
        <div class="event-cart-item">
          ${imgTag}
          <div class="event-cart-info">
            <div style="font-weight:600; margin-bottom:4px;">${title || "Item " + item.id}</div>

            <div class="event-cart-qty">
              <button class="event-cart-btn" onclick="eventQtyMinus(${item.id})">-</button>
              <span>${item.quantity}</span>
              <button class="event-cart-btn" onclick="eventQtyPlus(${item.id})">+</button>
            </div>

            <div style="margin-top:4px; font-size:14px;">
              ${unitPriceTxt}
            </div>
          </div>

          <button class="event-cart-remove" onclick="removeEventItem(${item.id})">Remove</button>
        </div>
      `;
    }

    totalEl.textContent = "£" + (total / 100).toFixed(2);
  };

  /***************************************************************
   * CONTROLES DE QTY EN POPUP
   ***************************************************************/
  window.eventQtyPlus = function (variantId) {
    let cart = loadLocalCart();
    let item = cart.items.find(i => i.id == variantId);
    if (!item) return;

    item.quantity++;
    saveLocalCart(cart);
    renderEventCartItems();
  };

  window.eventQtyMinus = function (variantId) {
    let cart = loadLocalCart();
    let item = cart.items.find(i => i.id == variantId);
    if (!item) return;

    if (item.quantity > 1) {
      item.quantity--;
    } else {
      cart.items = cart.items.filter(i => i.id != variantId);
    }
    saveLocalCart(cart);
    renderEventCartItems();
  };

  window.removeEventItem = function (variantId) {
    removeLocalItem(variantId);
    renderEventCartItems();
  };

  /***************************************************************
   * CHECKOUT EVENTO → SYNC A SHOPIFY
   ***************************************************************/
window.checkoutEventCart = async function () {
  console.log("🚀 START CHECKOUT EVENT");

  let cart = loadLocalCart();
  console.log("📦 Local cart:", cart);

  // Read event popup inputs
  const stand = document.getElementById("event-stand-number")?.value.trim();
  const contact = document.getElementById("event-onsite-contact")?.value.trim();
  const phone = document.getElementById("event-phone")?.value.trim();
  const tax = document.getElementById("event-tax")?.value.trim();
  const delivery = document.getElementById("event-delivery")?.value;
  const collection = document.getElementById("event-collection")?.value;
  const note = document.getElementById("event-note")?.value.trim();

  // Validation
  if (!stand || !contact) {
    alert("Please fill in Stand Number and On-site Contact before checkout.");
    console.warn("❌ Missing required fields");
    return;
  }

  console.log("📝 Checkout attributes:", {
    stand, contact, phone, tax, delivery, collection, note
  });

  // ---------------------------------------
  // 1️⃣ CLEAR SHOPIFY CART
  // ---------------------------------------
  console.log("🗑 Clearing Shopify cart...");
  await fetch("/cart/clear.js", { method: "POST" });

  // Wait small delay to avoid race conditions
  await new Promise(res => setTimeout(res, 150));

  // ---------------------------------------
  // 2️⃣ ADD ITEMS
  // ---------------------------------------
  if (cart.items.length > 0) {
    console.log("➕ Adding items to Shopify:", cart.items);

    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: cart.items })
    });
  } else {
    console.warn("⚠ No local cart items found!");
  }

  // AGAIN wait to avoid Shopify overwrite bug
  await new Promise(res => setTimeout(res, 200));

  // ---------------------------------------
  // 3️⃣ UPDATE ATTRIBUTES + NOTE
  // ---------------------------------------
  console.log("📨 Saving attributes to Shopify…");

  await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      attributes: {
        "Stand Number": stand,
        "On-site Contact": contact,
        "Contact Phone": phone,
        "Tax Number": tax,
        "Delivery Date": delivery,
        "Collection Date": collection
      },
      note: note || ""
    })
  });

  console.log("✅ Attributes saved.");

  // ---------------------------------------
  // 4️⃣ REDIRECT TO CHECKOUT
  // ---------------------------------------
  console.log("➡ Redirecting to checkout...");
  window.location.href = "/checkout";
};
});

